function clvInitReveal(root){
  var els = (root || document).querySelectorAll('.clv-reveal:not(.clv-reveal--ready):not(.clv-visible)');
  if(!els.length) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io;
  function showAll(){
    els.forEach(function(el){ el.classList.add('clv-visible'); });
    if(io) io.disconnect();
  }
  if(motion.matches || !('IntersectionObserver' in window)){
    showAll();
    return;
  }
  try{
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('clv-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function(el, i){
      el.style.setProperty('--clv-i', i % 8);
      el.classList.add('clv-reveal--ready');
      io.observe(el);
    });
  }catch(error){
    showAll();
  }
}

function clvInitTabs(){
  document.querySelectorAll('[data-clv-tabs]').forEach(function(wrap){
    if(wrap.dataset.clvTabsReady === 'true') return;
    wrap.dataset.clvTabsReady = 'true';

    var btns = wrap.querySelectorAll('[data-clv-tab-btn]');
    var panels = wrap.querySelectorAll('[data-clv-tab-panel]');
    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var idx = btn.getAttribute('data-clv-tab-btn');
        btns.forEach(function(b){ b.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = wrap.querySelector('[data-clv-tab-panel="' + idx + '"]');
        if(panel) panel.classList.add('is-active');
      });
    });
  });
}

function clvUpdateHeaderLinks(){
  document.querySelectorAll('#header-component a[href]').forEach(function(link){
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch(error) {
      return;
    }

    if(url.hash === '#clave-guia'){
      link.textContent = 'CÓMO ELEGIR';
      link.setAttribute('aria-label', 'Cómo elegir');
    }
  });
}

function clvInitHeader(){
  var actions = document.querySelector('#header-component header-actions');
  if(actions && !actions.querySelector('.clv-header-contact')){
    var contact = document.createElement('a');
    contact.href = '/pages/contact';
    contact.className = 'clv-header-contact';
    contact.textContent = 'CONTACTO';
    contact.setAttribute('aria-label', 'Contacto');

    var account = actions.querySelector('.account-button');
    actions.insertBefore(contact, account || actions.firstChild);
  }

  clvUpdateHeaderLinks();
}

function clvScheduleHeader(){
  clvInitHeader();
  window.setTimeout(clvInitHeader, 150);
  window.setTimeout(clvInitHeader, 500);
}

function clvScrollToAnchor(hash, updateHistory){
  if(hash !== '#clave-set' && hash !== '#clave-guia') return false;

  var target = document.querySelector(hash);
  if(!target) return false;

  var header = document.querySelector('#header-component');
  var headerHeight = header ? header.getBoundingClientRect().height : 72;
  var gap = window.innerWidth <= 749 ? 18 : 28;
  var targetY = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - gap;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.scrollTo({
    top: Math.max(0, targetY),
    behavior: reduceMotion ? 'auto' : 'smooth'
  });

  if(updateHistory && window.history && window.history.pushState){
    window.history.pushState(null, '', hash);
  }

  return true;
}

function clvFindAnchorFromEvent(event){
  if(event.composedPath){
    var path = event.composedPath();
    for(var i = 0; i < path.length; i++){
      if(path[i] && path[i].tagName === 'A' && path[i].hasAttribute('href')){
        return path[i];
      }
    }
  }

  return event.target && event.target.closest ? event.target.closest('a[href]') : null;
}

function clvCloseHeaderDrawer(link){
  if(!link || !link.closest) return;
  var drawer = link.closest('header-drawer');
  if(!drawer) return;

  try {
    if(typeof drawer.close === 'function'){
      drawer.close();
      return;
    }
  } catch(error) {
    // Fall back to closing the underlying details element directly.
  }

  var details = drawer.querySelector('details[open]');
  if(details){
    details.classList.remove('menu-open');
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if(summary) summary.setAttribute('aria-expanded', 'false');
  }
}

function clvInitAnchorScroll(){
  if(document.documentElement.dataset.clvAnchorScrollReady === 'true') return;
  document.documentElement.dataset.clvAnchorScrollReady = 'true';

  document.addEventListener('click', function(event){
    var link = clvFindAnchorFromEvent(event);
    if(!link) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch(error) {
      return;
    }

    if(url.hash !== '#clave-set' && url.hash !== '#clave-guia') return;

    // Never block Shopify's/native link navigation. We only close the mobile drawer
    // and, when the target is on the current page, correct the final scroll position.
    clvCloseHeaderDrawer(link);

    var samePage = url.origin === window.location.origin && url.pathname === window.location.pathname;
    if(samePage && document.querySelector(url.hash)){
      window.setTimeout(function(){
        clvScrollToAnchor(url.hash, false);
      }, 80);
    }
  });

  if(window.location.hash === '#clave-set' || window.location.hash === '#clave-guia'){
    window.setTimeout(function(){
      clvScrollToAnchor(window.location.hash, false);
    }, 120);
  }
}

document.addEventListener('DOMContentLoaded', function(){
  clvInitReveal();
  clvInitTabs();
  clvScheduleHeader();
  clvInitAnchorScroll();
});

document.addEventListener('shopify:section:load', function(event){
  clvInitReveal(event.target);
  clvInitTabs();
  clvScheduleHeader();
});
